import(/* webpackMode: "eager" */ "/vercel/path0/web/app/max/sample/page.tsx");
